import axios from 'axios';

import { env } from 'config';
import { OrderSciEventData } from 'types';

const baseUrl = `${env.apiUrl}/v1/customer/orders`;
const publicUrl = `${env.apiUrl}/v1/orders/sci-events/pre-auth`;

const create = async (
  orderId: string,
  data: OrderSciEventData,
): Promise<void> => {
  await axios.post(`${baseUrl}/${orderId}/sci-events`, data);
};

const createBatch = async (
  orderId: string,
  events: OrderSciEventData[],
): Promise<void> => {
  await axios.post(`${baseUrl}/${orderId}/sci-events/batch`, { events });
};

const createPublic = async (
  orderId: string,
  token: string,
  data: Pick<
    OrderSciEventData,
    'event' | 'message' | 'sessionId' | 'clientTimestamp'
  >,
): Promise<void> => {
  await axios.post(publicUrl, { orderId, token, ...data });
};

export const orderSciEventsApi = {
  create,
  createBatch,
  createPublic,
};
